import React from "react";

export const InfoScreen = () => {
    return (
        <>
            <img className={'logo'} src={"./images/geard_logo.svg"} alt={"gEARED!!"}/>
            <div>
                <div className={'k-flex-20'} style={{marginTop: ".5rem"}}>
                    <div className={'introText k-flex-30'}>
                        <p className={'thanks-partners'}>
                            Thank you to our sound partners<br />
                            <a href={"https://www.tiktok.com/@clutch2gear"} target={"_blank"} rel={"noreferrer"}>www.tiktok.com/@clutch2gear</a> and <a href={"https://www.pypesexhaust.com"} target={"_blank"} rel={"noreferrer"}>www.pypesexhaust.com</a>
                            <br />
                            <br />
                            AND… if you want your car’s sound to be a part of
                            the gEAR’D!!, just email us at <a href={"mailto:submit@geardgame.com"}>submit@geardgame.com</a>
                            <br />
                            <br />
                            We will need:<br />
                            - A video or audio file of your car revving or accelerating<br />
                            - Make, model, year and anything else (e.g. catless, etc.)<br />
                            - First name, city and state.<br />
                            Thanks for playing!!
                            <br />
                            <br />
                            <a href={"/result"} className={'more-info-btn'}>Back</a>
                        </p>

                    </div>
                </div>
            </div>
        </>
    );
};
